import React from "react";
import { safe } from "../utils/format";

export default function SummaryCard({ summary }) {
  return (
    <div className="top-card">
      <h2 style={{ fontSize: 20, fontWeight: 700 }}>Diya's Note</h2>

      <p style={{ marginTop: 12, fontSize: 18, color: "#555", lineHeight: "22px" }}>
        {safe(summary)}
      </p>
    </div>
  );
}
